<template>
    <form @submit="submit" class="item-editor-form">
        <fg-input v-model="item.tunnus" :label="$t('stop_view.id')" :disabled="action == 'edit'"></fg-input>
        <fg-input v-model="item.nimi" :label="$t('stop_view.name')" :disabled="inputDisabled"></fg-input>
        <fg-input v-model="item.sms" :label="$t('stop_view.identifier')" :disabled="inputDisabled"></fg-input>
        <fg-input v-model="item.laituri" :label="$t('stop_view.platform')" :disabled="inputDisabled"></fg-input>
        <b-row>
            <b-col>
                 <label for="longitude">{{ $t('stop_view.latitude') }}:</label>
                <floatInput v-model="item.location.latitude" id="latitude" :disabled="inputDisabled"></floatInput>
            </b-col>
            <b-col>
                 <label for="longitude">{{ $t('stop_view.longitude') }}:</label>
                <floatInput v-model="item.location.longitude" id="longitude" :disabled="inputDisabled"></floatInput>
            </b-col>
        </b-row>

        <div v-if="action == 'edit'" class="stop-features">
            <div v-for="orgStopFeature in organisationStopFeatures" :key="orgStopFeature.id">
                <div v-if="orgStopFeature.type === 'BOOLEAN'" class="stop-feature">
                    <label>{{ $t(orgStopFeature.descriptionId) }}</label>
                    <b-form-checkbox value="true" unchecked-value="false" v-model="item.stopFeatures[orgStopFeature.name]" :disabled="inputDisabled"/>
                </div>
                <div v-else-if="orgStopFeature.type === 'SELECT'">
                    <label>{{ $t(orgStopFeature.descriptionId) }}</label>
                    <vSelect :options="orgStopFeature.validValues" v-model="item.stopFeatures[orgStopFeature.name]" :disabled="inputDisabled" />
                </div>
                <div v-else>
                    <fg-input :label="$t(orgStopFeature.descriptionId)" v-model="item.stopFeatures[orgStopFeature.name]" :disabled="inputDisabled"/>
                </div>
            </div>
        </div>
        
        <FormButtons
            @submit="submit"
            :submit="$UIPrivilegeU('timetables/stops')"   
            :reset="false" 
            @remove="remove"
            :remove="action == 'edit' && $UIPrivilegeD('timetables/stops')" 
            :itemid="this.item.tunnus"
            :modalid="'stopEditModal'"
            :disableSubmit="loading"
            :disableRemove="loading "/>

        <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />
    
    </form>
    
</template>

<script>
import FormButtons from '@/components/Misc/FormButtons'
import floatInput from '@/components/Generic/FloatInput'
import timetable from '@/store/timetable/timetable'

export default {
    components: {
        FormButtons, floatInput
    },
    props: {
        item: {        
            default: function () {
                return {
                    "tunnus": null,
                    "nimi": null,
                    "sms": null,
                    "laituri": null, 
                    "location" : {
                        "latitude" :null, 
                        "longitude" : null
                    },
                    "stopFeatures": {}
                }
            }        
         },
        action: { default: "new" }
    },
    data: function() {
        return  {
            ok: false,
            error: false,
            loading: false,
            infoType: "save"
        }
    },    
    beforeCreate: function() {
        if (!this.$store.state.timetable) {
            this.$store.registerModule("timetable" , timetable);
        }
        this.$store.dispatch('timetable/getOrganisationStopFeatures');
    },
    computed: {
        organisationStopFeatures() {
            return this.$store.state.timetable.organisationStopFeatures.list;
        },
        
        inputDisabled(){
            return this.loading || !this.$UIPrivilegeU('timetables/stops');
        }
    },
    watch: {
        item(){
            this.ok = this.error = this.loading = false; 

            if (!this.item.stopFeatures || this.item.stopFeatures.length === 0) {
                var lista = [];
                var feature = new Map();

                for (var f of this.$store.state.timetable.organisationStopFeatures.list) {
                    feature.set(f.name,"false");
                    lista.push(feature);

                }
                this.item.stopFeatures = feature;
            }           
    
        }
    },
    methods: {
        getOrganisationStopFeatures() {
            this.$store.dispatch('timetable/getOrganisationStopFeatures');
        },
        submit(event) {
            if( event ) 
                event.preventDefault();

            if (this.item.stopFeatures.length === 0) {
                this.item.stopFeatures = {};
            }
            this.ok = this.error = false;
            this.infoType = "save";
            this.loading = true;
            
            setTimeout(() => { 
                this.$store.dispatch('stop/updateStop' , this.item).then(response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                })
                .catch( () => { 
                    this.error = true; 
                }) 
                .finally(() => {
                    this.loading = false;
                    this.item.location.latitude = null
                    this.item.location.longitude = null
                })
            }, 1000);
        },
        reset(event){
            event.preventDefault();
            this.item = {};              
        },
        remove() {
            this.infoType = "delete";
            this.loading = true;
            setTimeout(() => { 
                this.$store.dispatch('stop/deleteStop' , this.item.tunnus).then(response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                }) 
                .catch( () => { 
                    this.error = true; 
                }) 
                .finally(() => {
                    this.loading = false;
                })
            }, 1000);
        }
    }
}
</script>
<style lang="scss" scoped>

.stop-features {
    padding-top: 1em;
    padding-bottom: 0.5em;
}
.stop-feature {
    display: flex;
    flex-direction: row;
    label {
        width: 50%;
    }
}

</style>
